import { render, staticRenderFns } from "./DeliveryPointList.vue?vue&type=template&id=8cb3908a&scoped=true"
import script from "./DeliveryPointList.vue?vue&type=script&lang=js"
export * from "./DeliveryPointList.vue?vue&type=script&lang=js"
import style0 from "./DeliveryPointList.vue?vue&type=style&index=0&id=8cb3908a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cb3908a",
  null
  
)

export default component.exports